import React from 'react';
import { footerData } from '../data/mock';
import { getPublicSettings } from '../services/api';
import { useState, useEffect } from 'react';
import { TreePine, Mail, Phone, MapPin, Instagram, Facebook, Twitter, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
    const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getPublicSettings();
        setSettings(data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const contactEmail = settings?.contact_email || footerData.contact.email;
  const contactPhone = settings?.contact_phone || footerData.contact.phone;
  const contactAddress = settings?.contact_address || footerData.contact.address;

  return (
    <footer id="contact" className="bg-stone-950 border-t border-stone-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2 mb-6">
              <TreePine className="w-8 h-8 text-emerald-400" />
              <span className="text-xl font-semibold text-white tracking-wide">
                Stay <span className="text-emerald-400">Tran-Quil</span>
              </span>
            </a>
            <p className="text-stone-400 leading-relaxed mb-6 max-w-md">
              Your private riverfront escape in beautiful Manitoba. Disconnect from the world and reconnect with nature at our cozy cabin retreat.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href={footerData.social.instagram}
                className="w-10 h-10 bg-stone-800 hover:bg-emerald-500/20 border border-stone-700 hover:border-emerald-500/50 rounded-full flex items-center justify-center text-stone-400 hover:text-emerald-400 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={footerData.social.facebook}
                className="w-10 h-10 bg-stone-800 hover:bg-emerald-500/20 border border-stone-700 hover:border-emerald-500/50 rounded-full flex items-center justify-center text-stone-400 hover:text-emerald-400 transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={footerData.social.twitter}
                className="w-10 h-10 bg-stone-800 hover:bg-emerald-500/20 border border-stone-700 hover:border-emerald-500/50 rounded-full flex items-center justify-center text-stone-400 hover:text-emerald-400 transition-all duration-300"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-stone-400 hover:text-emerald-400 transition-colors">
                  About the Cabin
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-stone-400 hover:text-emerald-400 transition-colors">
                  Photo Gallery
                </a>
              </li>
              <li>
                <a href="#activities" className="text-stone-400 hover:text-emerald-400 transition-colors">
                  Activities
                </a>
              </li>
              <li>
                <a href="#booking" className="text-stone-400 hover:text-emerald-400 transition-colors">
                  Book Your Stay
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${contactEmail}`}
                  className="flex items-center gap-3 text-stone-400 hover:text-emerald-400 transition-colors group"
                >
                  <Mail className="w-5 h-5 text-emerald-400/70 group-hover:text-emerald-400" />
                  <span>{contactEmail}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contactPhone}`}
                  className="flex items-center gap-3 text-stone-400 hover:text-emerald-400 transition-colors group"
                >
                  <Phone className="w-5 h-5 text-emerald-400/70 group-hover:text-emerald-400" />
                  <span>{contactPhone}</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-stone-400">
                  <MapPin className="w-5 h-5 text-emerald-400/70" />
                  <span>{contactAddress}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-stone-500 text-sm">
              &copy; {currentYear} Stay Tran-Quil. All rights reserved.
            </p>
            <p className="text-stone-500 text-sm flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-red-400" /> in Manitoba | Hosted on Hostinger Cloud Startup
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
